// frontend/src/themes/palettes/floresta.js
import { sharedComponents } from "./shared";
export default {
  muiMode: "light",
  scrollbarColor: "#A8C8A0",
  palette: {
    primary:    { main: "#2E7D32" },
    secondary:  { main: "#8D6E63" },
    background: { default: "#F3F7EF", paper: "#FFFFFF" },
    text:       { primary: "#1E3B20", secondary: "#4E6A50" },
    divider:    "#D5E4CE",
    action:     { hover: "rgba(46,125,50,0.05)", selected: "rgba(46,125,50,0.09)" },
  },
  components: {
    ...sharedComponents,
    MuiOutlinedInput: {
      styleOverrides: {
        root: { borderRadius: 6, backgroundColor: "#FFFFFF" },
        notchedOutline: { borderColor: "#B4CCAC" },
      },
    },
  },
  custom: {
    chat: { sentBg: "#E1F0DC", quotedSentBg: "#D2E6CB", quotedReceivedBg: "#EFF5EC", accent: "#2E7D32", contactAccent: "#8D6E63" },
    chartPalette: ["#2E7D32", "#8D6E63", "#66BB6A", "#FF7043", "#26A69A", "#9CCC65"],
    login: { bg: "#F3F7EF" },
  },
};
